import { render, staticRenderFns } from "./CourseDropDownCardSkeleton.vue?vue&type=template&id=5369898d&scoped=true&"
import script from "./CourseDropDownCardSkeleton.vue?vue&type=script&lang=js&"
export * from "./CourseDropDownCardSkeleton.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "5369898d",
  null
  
)

export default component.exports